<template>
  <div>
    <el-dialog :title="`密码修改`" :close-on-click-modal="false" custom-class="h-dialog-add" :visible.sync="bEditPasswordDialogShow" width="95%" @close="handleClearForm()">
      <el-form :model="oEditPasswordRuleForm" ref="oEditPasswordRuleForm" label-position="right" label-width="95px">
        <span class="dialog-mes" v-show="mes != ''">{{ mes }}</span>
        <el-form-item prop="oldPassword" label="原始密码" :rules="[
            { required: true, message: '原始密码不能为空', trigger: 'change' },
            { pattern: '', message: '原始密码不能为空', trigger: 'change' }
          ]">
          <el-input :type="oldTextType" autocomplete="new-password" v-model="oEditPasswordRuleForm.oldPassword" placeholder="请输入原始密码" maxlength="50"></el-input>
          <span class="u-icon" :class="oldIsText ? 'u-icon-visible' : ''" @click="oldIconClick"></span>
        </el-form-item>
        <el-form-item prop="password" label="新密码" :rules="[
            { required: true, message: '新密码不能为空', trigger: 'change' },
            { pattern: '(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,}', message: '8位及以上数字、字母、字符组合', trigger: 'change' }
          ]">
          <el-input :type="newTextType" autocomplete="new-password" v-model="oEditPasswordRuleForm.password" placeholder="请输入密码" maxlength="50"></el-input>
          <span class="u-icon" :class="newIsText ? 'u-icon-visible' : ''" @click="newIconClick"></span>
        </el-form-item>
        <el-form-item prop="comfirmPassword" label="确认密码" :rules="[
            { required: true, message: '确认密码不能为空', trigger: 'change' },
            { validator: passwordValidate, trigger: 'change' },
            { pattern: '(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,}', message: '8位及以上数字、字母、字符组合', trigger: 'change' }
          ]">
          <el-input :type="textType" autocomplete="new-password" v-model="oEditPasswordRuleForm.comfirmPassword" placeholder="请输入确认密码" maxlength="50"></el-input>
          <span class="u-icon" :class="isText ? 'u-icon-visible' : ''" @click="iconClick"></span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer dialog-footer-default">
        <el-button @click="handleClearForm">取消</el-button>
        <el-button type="primary" @click="handleEditPasswordSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { sm3 } from 'sm-crypto';
export default {
  components: {},
  data() {
    return {
      bEditPasswordDialogShow: false, // 弹出框开关
      message: '',
      mes: '', //提示语
      name: '', //账号名称
      oEditPasswordRuleForm: {
        oldPassword: '', //原始密码
        password: '',
        comfirmPassword: ''
      },
      from: '',
      passwordType: '',
      data: {},
      oldTextType: 'password',
      oldIsText: false,
      newTextType: 'password',
      newIsText: false,
      textType: 'password',
      isText: false
    };
  },
  activated() { },
  computed: {
    token() {
      return window.sessionStorage.getItem('token');
    }
  },
  methods: {
    // 密码验证
    passwordValidate(rule, value, callback) {
      if (value !== this.oEditPasswordRuleForm.password) {
        callback(new Error('确认密码与新密码不一致'));
      } else {
        callback();
      }
    },
    // 提交
    handleEditPasswordSubmit() {
      this.$refs.oEditPasswordRuleForm.validate(valid => {
        if (valid) {
          let params = {
            username: this.username,
            oldPassword: sm3(this.$md5(this.oEditPasswordRuleForm.oldPassword)),
            newPassword: sm3(this.$md5(this.oEditPasswordRuleForm.comfirmPassword)),
          };
          if (this.oEditPasswordRuleForm.oldPassword === this.oEditPasswordRuleForm.comfirmPassword) {
            this.$message.error('原始密码和新密码一致，请重新输入新密码');
          } else {
            this.$http.post(this.$API.password_updatePwdByUserName, params).then(res => {
              if (res.success) {
                this.bEditPasswordDialogShow = false;
                this.$message.success(res.msg);
                if (this.from == 'verity') {
                  this.$router.push({ path: '/login' });
                }
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        }
      });
    },
    handleEdit() {
      this.bEditPasswordDialogShow = true;
    },
    //表单清空
    handleClearForm() {
      this.bEditPasswordDialogShow = false;
      this.bForgetPasswordDialogShow = false;
      this.$refs.oEditPasswordRuleForm.resetFields();
      this.$router.push({ path: '/login' });
    },
    // 初始化弹出框
    openModal(name, from) {
      this.bEditPasswordDialogShow = true;
      this.username = name;
      this.from = from;

      this.oEditPasswordRuleForm = {
        oldPassword: '', //原始密码
        password: '',
        comfirmPassword: ''
      }

      this.oldTextType = 'password';
      this.oldIsText = false;
      this.newTextType = 'password';
      this.newIsText = false;
      this.textType = 'password';
      this.isText = false;
    },
    //密码隐藏与显示
    oldIconClick() {
      if (this.oldIsText) {
        this.oldTextType = 'password';
      } else {
        this.oldTextType = 'text';
      }
      this.oldIsText = !this.oldIsText;
    },
    newIconClick() {
      if (this.newIsText) {
        this.newTextType = 'password';
      } else {
        this.newTextType = 'text';
      }
      this.newIsText = !this.newIsText;
    },
    iconClick() {
      if (this.isText) {
        this.textType = 'password';
      } else {
        this.textType = 'text';
      }
      this.isText = !this.isText;
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-mes {
  display: block;
  margin: 10px 0;
}
.el-dialog__body {
  padding: 10px 20px;
}
.u-icon {
  position: absolute !important;
  display: inline-block;
  width: 40px;
  height: 40px;
  top: 0px;
  right: 5px;
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: 5px;
  position: relative;
  vertical-align: middle;
  background-image: url(https://pic.icar56.com/icar56/images/comment/icons-login.png);
  background-repeat: no-repeat;
  background-position: 11px -20px;
  cursor: pointer;
}
.u-icon.u-icon-visible {
  cursor: pointer;
  background: url(https://pic.icar56.com/icar56/images/comment/icons-login.png)
    no-repeat 11px 13px;
}
</style>

<style lang="scss">
.el-dialog__footer {
  .dialog-footer-default {
    .el-button--primary {
      background-color: #2f70ff !important;
      border-color: #2f70ff;
    }
  }
}
</style>
